<template>
<b-card no-body>
  <validation-observer
    v-slot="{ handleSubmit }" ref="VForm"
  >
    <b-form @submit.prevent="handleSubmit($parent.doSubmitCRUD('VForm', $refs))">
      <b-card-header>
        <b-row>
          <b-col lg="8">
            <h5 class="card-title">{{ $parent.isAdd?'Add':'Edit' }} {{ $parent.pageTitle }}</h5>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col lg="4">
            <b-form-group label-for="catName">
              <label>Category Name (ID)<span class="text-danger mr5">*</span></label>
              <b-form-input @keyup="$parent.removeWildChar" @keydown="$parent.removeWildChar" v-model="row.abc_name_id" placeholder="e.g Teknologi" />
              <VValidate 
                name="Category Name (ID)" 
                v-model="row.abc_name_id" 
                :rules="{...mrValidation.abc_name_id, regex:/^[^\s]+(\s+[^\s]+)*$/}" 
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label-for="catNameEn">
              <label>Category Name (EN)<span class="text-danger mr5">*</span></label>
              <b-form-input @keyup="$parent.removeWildChar" @keydown="$parent.removeWildChar" v-model="row.abc_name_en" placeholder="e.g Technology" />
              <VValidate 
                name="Category Name (EN)" 
                v-model="row.abc_name_en" 
                :rules="{...mrValidation.abc_name_en, regex:/^[^\s]+(\s+[^\s]+)*$/}" 
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group label-for="catNameEn">
              <label>Category Name (JP)<span class="text-danger mr5">*</span></label>
              <b-form-input v-model="row.abc_name_jp" placeholder="e.g テクノロジー" />
              <VValidate 
                name="Category Name (JP)" 
                v-model="row.abc_name_jp" 
                :rules="mrValidation.abc_name_jp" 
              />
            </b-form-group>
          </b-col>
          <b-col lg="12">
            <b-form-group label-for="catStatus">
              <label>Status <span class="text-danger mr5">*</span></label>
              <b-form-radio-group
                :options="Config.mr.StatusOptions"
                v-model="row[$parent.statusKey]"
              />
              <VValidate 
                name="Status" 
                v-model="row[$parent.statusKey]" 
                :rules="mrValidation[$parent.statusKey]" 
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer>
        <b-row>
          <b-col lg="12" class="text-right">
            <button @click="$router.back()" type="button" class="btn  btn-rounded  btn-default mr-3">Cancel</button>
            <b-button type="submit" variant="primary" class="btn-rounded">Save Changes</b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-form>
  </validation-observer>
</b-card>
</template>

<script>
export default{
  props:{
    row:Object,
    mrValidation:Object,
    Config:Object
  },
  data(){
    return {
      mrCatType:[]
    }
  },
}
</script>